import { Logo } from '@/common'
import { EntityConfig } from './MesReportEmbed'
import chalcoLogo from './chalco_logo.svg'
import useI18n from '@/shared/hooks/useI18n'

export default function MesReportCoverPage({
  operatorName,
  cnCodes,
  startDate,
  endDate,
  productionRouteName,
  finalizedDate,
  entityConfig
}: {
  startDate: string
  endDate: string
  creationDate: string
  operatorName: string
  finalizedDate: string
  cnCodes: {
    methodCode: string
    cnCode: string
  }[]
  productionRouteName: string
  entityConfig: EntityConfig
}) {
  const { t } = useI18n()
  return (
    <div className="break-after-page min-h-[100vh] flex flex-col shadow-lg print:shadow-none justify-center items-center text-center bg-white">
      <header className="flex flex-col items-center justify-center">
        <img src={chalcoLogo} alt="Chalco Logo" className="w-32 mb-4" />
        <h1 className="font-bold text-lg">{operatorName}</h1>
      </header>
      <main className="text-text-secondary flex flex-col items-center justify-center">
        <p className="mt-2">
          For the Reporting Period
          <br />
          from {startDate} to {endDate}
        </p>
        <p className="italic text-xs mt-2">Report Created on {finalizedDate}</p>
        <p className="text-xs mt-2 mx-44 text-center">
          Prepared in accordance with the legislative requirements stipulated pursuant to Regulation
          (EU) 2023/956 of 10 May 2023 and Implementing Regulation (EU) 2023/1773 of 17 August 2023.
        </p>
        <div className="mt-10">
          <table className="w-full border-b">
            <thead>
              <tr className="text-left">
                <th className="py-2 px-2 font-normal">CN Code</th>
                <th className="py-2 px-2 font-normal">Production Route</th>
                <th className="py-2 px-2 font-normal">Production Method</th>
              </tr>
            </thead>
            <tbody className="bg-background-main">
              {cnCodes.map(item => (
                <tr key={item.methodCode} className="border-t">
                  <td className="py-2 px-2 font-semibold">{item.cnCode}</td>
                  <td className="py-2 px-2 font-semibold">{productionRouteName}</td>
                  <td className="py-2 px-2 font-semibold">
                    {t(`common:productionMethods.${item.methodCode}`)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex flex-col items-center justify-center mt-32">
          <Logo className="w-32 h-12" />
          <p className="text-xs">
            {entityConfig.entityName} - {entityConfig.street}
            <br />
            {entityConfig.city}, {entityConfig.country}
          </p>
        </div>
      </main>
    </div>
  )
}
